module.exports = __webpack_public_path__ + "assets/img/testi2.b6650e16.jpg";